import { InvalidGalleryContentError } from '../../domain/errors/InvalidGalleryContentError';
import type { GalleryRepository } from '../../domain/repositories/GalleryRepository.interface';
import type { GalleryViewDto } from '../dto/GalleryDto';
import { ApplicationError, type Logger } from '@dma/shared';

/**
 * Returns the combined albums + all items in a single call — the Gallery
 * page needs both to render an album-filterable grid. Kept as one use case
 * rather than two separate calls to avoid an unnecessary extra round trip
 * once this moves to a real Supabase-backed source.
 */
export class GetGalleryUseCase {
  constructor(
    private readonly repository: GalleryRepository,
    private readonly logger: Logger
  ) {}

  public async execute(): Promise<GalleryViewDto> {
    try {
      const [albums, items] = await Promise.all([
        this.repository.getAlbums(),
        this.repository.getAllItems()
      ]);
      return {
        albums: albums.map((album) => album.props),
        items: items.map((item) => item.props)
      };
    } catch (error) {
      if (error instanceof InvalidGalleryContentError) {
        this.logger.error('Gallery content failed domain validation', {
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('GALLERY_UNAVAILABLE', 'گالری در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }
  }
}
